export default __webpack_public_path__ + "static/media/Foggy cenote2.f1c85637.jpg";